import { useEffect, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerLink,
  DrawerLinks,
} from "../styled/Header.styled";
import {
  EarnObject,
  ElectricObject,
  ReferralsObject,
  ResourcesObject,
  SupportObject,
  getHeaderLink,
} from "./data";
import { Container } from "@mui/material";

export const PCDrawer = ({ isOpen, content, onMouseEnter, onMouseLeave }) => {
  const [drawerContent, setDrawerContent] = useState<any>();

  useEffect(() => {
    if (content) {
      getContent(content);
    }
    // test drawer
    // getContent(2);
  }, [content]);

  const getContent = (val) => {
    switch (val) {
      case 1:
        setDrawerContent(ElectricObject);
        break;
      case 2:
        setDrawerContent(EarnObject);
        break;
      case 3:
        setDrawerContent(ReferralsObject);
        break;
      case 4:
        setDrawerContent(ResourcesObject);
        break;
      case 5:
        setDrawerContent(SupportObject);
        break;
    }
  };

  return (
    <Drawer
      className={isOpen ? "open" : "close"}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Container>
        <DrawerContent>
          {
          content &&
            drawerContent &&
            Object.entries(drawerContent).map(([category, items]: any) => (
              <DrawerLinks>
                {category === "Other" ? (
                  <a style={{height:"26px"}}>{'      '}</a>
                ) : (
                  <a href={getHeaderLink(category)} className="link-title">
                    {category}
                  </a>
                )}
                {items.map((item, index) => (
                  <DrawerLink key={index}>
                    <a href={item.link}>{item.title}</a>
                  </DrawerLink>
                ))}
              </DrawerLinks>
            ))}
        </DrawerContent>
      </Container>
    </Drawer>
  );
};
